export const RECEIVE_BHC_COMPANY_LOCATIONS = 'RECEIVE_BHC_COMPANY_LOCATIONS';

export const receiveBHCLocations = items => ({
  type: RECEIVE_BHC_COMPANY_LOCATIONS,
  items,
});
